<template>
  <v-container class="cmp-distribution-suppliers-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedSupplierDetails &&
              selectedSupplierDetails.supplier &&
              selectedSupplierDetails.supplier.supplier_name
            "
          >
            <span
              v-if="selectedSupplierDetails && selectedSupplierDetails.supplier"
              >{{
                selectedSupplierDetails.supplier.supplier_name ||
                $t('supplier_name')
              }}</span
            >
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div
                v-if="
                  selectedSupplierDetails && selectedSupplierDetails.supplier
                "
              >
                {{
                  selectedSupplierDetails.supplier.supplier_name ||
                $t('supplier_name')
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="supplierSidewindowTabs"
        :loading="selectedSupplierDetails && selectedSupplierDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('supplier_setup_string')" h="163">
                <SupplierSetup
                  :selectedSupplierDetails="selectedSupplierDetails"
                  @changed="onSupplierChanged"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedSupplierDetails &&
                      selectedSupplierDetails.contact_relations &&
                      selectedSupplierDetails.contact_relations.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('related_contacts')"
              >
                <RelatedContacts
                  :contact_relations="selectedSupplierDetails.contact_relations"
                  :external_id="`${selectedSupplierDetails.supplier.supplier_id}`"
                  :external_table="'supplier'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedSupplierDetails &&
                      selectedSupplierDetails.files &&
                      selectedSupplierDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedSupplierDetails.files"
                  :externalId="`${this.selectedSupplierDetails.supplier.supplier_id}`"
                  :externalTable="'supplier'"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('invoice_contact')">
                <InvoiceContact
                  :invoiceContact="
                    selectedSupplierDetails.invoice_contact || {}
                  "
                  :contactConfig="{
                    external_id: selectedSupplierDetails.supplier.supplier_id,
                    external_table: 'l_suppliers',
                    external_name: 'contact_id_invoice',
                    config_type: 'DistributionSupplierInvoiceConfig',
                    key: 'supplier_id',
                  }"
                />
              </gbox>
              <gbox :title="$t('delivery_address')">
                <InvoiceContact
                  :invoiceContact="
                    selectedSupplierDetails.delivery_contact || {}
                  "
                  :contactConfig="{
                    external_id: selectedSupplierDetails.supplier.supplier_id,
                    external_table: 'l_suppliers',
                    external_name: 'contact_id_delivery',
                    config_type: 'DistributionSupplierDeliveryConfig',
                    key: 'supplier_id',
                  }"
                />
              </gbox>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedSupplierDetails.supplier.notes"
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="catalogue">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowHeight: 62,
                    rowCount:
                      selectedSupplierDetails &&
                      selectedSupplierDetails.products &&
                      selectedSupplierDetails.products.length,
                    offset:
                      selectedSupplierDetails &&
                      selectedSupplierDetails.products &&
                      selectedSupplierDetails.products.length > 0
                        ? catalogueSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52 + 16
                          : NTOffsets.WithHeaderDBoxBottom + 16
                        : catalogueSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52 + 16
                        : NTOffsets.WithHeaderDBoxBottom + 16,
                  })
                "
                :title="$dft.capHead($t('tab_title_catalogue'))"
              >
                <CatalogueList
                  @showSearchFlag="onCatalogSearchClick"
                  @changed="onSupplierItemChanged"
                  @add_click="onAddClick"
                  :selectedSupplierDetails="selectedSupplierDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="orders">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedSupplierDetails &&
                      selectedSupplierDetails.orders &&
                      selectedSupplierDetails.orders.length,
                    NTOffsets.withHeaderDBoxBottom
                  )
                "
                :title="$t('submenu_Orders')"
              >
                <OrderList
                  @changed="onSupplierOrderItemChanged"
                  @add_click="onAddClick"
                  @added="onOrderAdded"
                  :selectedSupplierDetails="selectedSupplierDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="tab_title_stock_check">
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowHeight: 62,
                    rowCount:
                      selectedSupplierDetails &&
                      selectedSupplierDetails.stocKProducts &&
                      selectedSupplierDetails.stocKProducts.length,
                    offset:
                      selectedSupplierDetails &&
                      selectedSupplierDetails.stocKProducts &&
                      selectedSupplierDetails.stocKProducts.length > 0
                        ? stockCheckSearchFlag
                          ? NTOffsets.WithHeaderDBoxBottom + 52 + 20
                          : NTOffsets.WithHeaderDBoxBottom + 20
                        : stockCheckSearchFlag
                        ? NTOffsets.WithHeaderDBoxBottom + 52 + 20
                        : NTOffsets.WithHeaderDBoxBottom + 20,
                  })
                "
                :title="$t('tab_title_stock_check')"
              >
                <StockCheck
                  @showSearchFlag="onStockCheckSearchClick"
                  @filtered="onStockCheckFilteredClick"
                  @add_click="onAddClick"
                  @added="onSupplyOrderAdded"
                  :selectedSupplierDetails="selectedSupplierDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <ModalContainer :modalKey="'addCatalogueForm'" :width="'medium'">
      <AddCatalogueForm
        @cancelled="onDialogCancelled"
        @added="onSupplierProductAdded"
        :selectedSupplierDetails="selectedSupplierDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addOrderForm'" :width="'small'">
      <AddOrderForm
        @cancelled="onDialogCancelled"
        @added="onOrderAdded"
        :selectedSupplierDetails="selectedSupplierDetails"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'addNewStock'" :width="'small'">
      <AddNewStock
        @cancelled="onDialogCancelled"
        @added="onOrderAdded"
        :selectedSupplierDetails="selectedSupplierDetails"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { distributionSupplierActions } from "../../store/suppliers/actions";
import { createTV } from "../../../../models/text-value.model";
import { distributionSupplierGetters } from "../../store/suppliers/getters";
import { distributionSupplierListLDTRoutes } from "../../router/routes";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { checkTabListPermission } from "../../../../router/guard";
import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";

import { SuppliersService } from "../../services/suppliers.service";
import CatalogueList from "./catalogue-list.vue";
import AddCatalogueForm from "./add-catalogue-form.vue";
import OrderList from "./order-list.vue";
import StockCheck from "./stock-check.vue";
import SupplierSetup from "./supplier-setup.vue";
import AddOrderForm from "./add-order-form.vue";
import AddNewStock from "./add-new-stock.vue";
import RelatedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import ModalContainer from "@dtplugins/modal/modal-container";
import InvoiceContact from "@/dt-plugins/dbox-invoice-contact/dbox-invoice-contact.vue";
import { distributionSupplierOrderListLDTRoutes } from "../../router/routes";
export const moduleRoute = "royalty";
export const submenuRoute = "accounts";
import { groupBy } from "lodash";

export default {
  components: {
    BoxWidget,
    DBoxTextarea,
    DBoxFiles,
    ModalContainer,
    CatalogueList,
    OrderList,
    SupplierSetup,
    RelatedContacts,
    AddOrderForm,
    InvoiceContact,
    AddCatalogueForm,
    StockCheck,
    AddNewStock,
  },
  data() {
    return { catalogueSearchFlag: false, stockCheckSearchFlag: false };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addOrderForm"),
    createModalMixin("addCatalogueForm"),
    createModalMixin("addNewStock"),
    // createModalMixin("addStatementForm"),
    // createModalMixin("editPaymentForm"),
    // createModalMixin("addInvoiceContactForm"),
    // createModalMixin("addDeliveryAddressForm"),
    // createModalMixin("copyContractForm"),
    // createModalMixin("harryFoxContractForm"),
    // createModalMixin("contractDocumentTemplate"),
  ],
  computed: {
    ...mapGetterObject(storeNS, distributionSupplierGetters),

    supplierSidewindowTabs: function () {
      return checkTabListPermission(
        moduleRoute,
        submenuRoute,
        this.selectedSupplierDetails?.supplier?.supply_order_type !== 1
          ? [
              {
                route: "overview",
                value: this.$t("overview"),
              },
              {
                route: "catalogue",
                value: this.$t("catalogue"),
                vgi_id: "catalogue",
              },
              {
                route: "orders",
                value: this.$t("orders"),
              },
              {
                route: "tab_title_stock_check",
                value: this.$t("tab_title_stock_check"),
              },
            ]
          : [
              {
                route: "overview",
                value: this.$t("overview"),
              },
              {
                route: "catalogue",
                value: this.$t("catalogue"),
                vgi_id: "catalogue",
              },
              {
                route: "orders",
                value: this.$t("orders"),
              },
            ]
      );
    },
    // TABULATION REFACTORING

    supplier_id: function () {
      return this.$route.params.supplier_id;
    },

    selectedSupplierDetails: function () {
      const selectedSupplier = this.supplierDetails?.[this.supplier_id] || {};
      console.log("selected Supplier", selectedSupplier);
      const supplier = selectedSupplier?.supplier || {};
      console.log("Supplier", supplier);

      const invoice_projects = selectedSupplier?.invoice_projects || [];

      const currencies = selectedSupplier?.currencies || [];

      const product_TypesTV = createTV(
        selectedSupplier?.product_types || [],
        "product_type_name",
        "product_type_id"
      );
      const release_monthsTV = createTV(
        selectedSupplier?.release_months || [],
        "release_month",
        "release_month"
      );
      // const currencyTV = createTV(
      //   selectedSupplier?.currencies || [],
      //   "currency_iso",
      //   "currency_id"
      // );

      return {
        ...selectedSupplier,
        invoice_projects,
        product_TypesTV,
        currencies,
        supplier,
        release_monthsTV,
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionSupplierActions),
    onRelatedContactSelected: function () {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview",
        },
      });
    },
    onCatalogSearchClick: function (payload) {
      this.catalogueSearchFlag = payload;
    },
    onStockCheckSearchClick: function (payload) {
      this.stockCheckSearchFlag = payload;
    },

    onSupplierProductAdded: function (e) {
      this[ActionTypes.DistributionSupplierCatalogue.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        products: e || [],
      });
      this.onDialogCancelled();
    },
    onRelatedContactDelete: function (contact) {
      this[ActionTypes.SupplierRelatedContacts.DELETE.SINGLE]({
        contact,
        selectedSupplierDetails: this.selectedSupplierDetails,
      });
    },
    onRelatedContactChange: function ({ name, value, item }) {
      this[ActionTypes.SupplierRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedSupplierDetails: this.selectedSupplierDetails,
      });
    },

    async onOrderAdded(order) {
      const res = await SuppliersService.fetchDistributionSupplierOrderTabSetup(
        this.supplier_id
      );
      this[ActionTypes.DistributionSupplierOrderList.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        orders: [...res.data.orders] || [],
      });
      this.$router.push({
        name: distributionSupplierOrderListLDTRoutes.names.tab,
        params: {
          supplier_order_id: order.supplier_order_id,
          tab: "overview",
        },
      });
    },
    onCopyContractAdded: function (e) {},
    onSupplierChanged: function (payload) {
      console.log("Changed value ", payload);
      this[ActionTypes.SupplierDetails.UPDATE.SINGLE]({
        ...payload,
        selectedSupplierDetails: this.selectedSupplierDetails,
      });
    },

    onSelectedAccount: function (selectedRoyaltyAccountId) {
      this.$router.push({
        name: distributionSupplierListLDTRoutes.names.tab,
        params: {
          supplier_id: selectedRoyaltyAccountId,
          tab: "overview",
        },
      });
    },
    onNotesBlur: function (event) {
      this.onSupplierChanged({
        name: "notes",
        value: event.target.value,
      });
    },
    // MARK: Methods

    onAdded: function (payload) {
      this.onDialogCancelled();
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddClick: function (e) {
      openModalRoute(this, e, {
        mode: "add",
      });
    },
    onEditClick: function (e) {
      openModalRoute(this, "edit_payment_form", {
        mode: "add",
      });
      this.selectedPayment = {
        ...e,
      };
    },
    onContactAdded: function (e) {
      this[ActionTypes.RoyaltyAccountsMainContacts.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        contact: e || {},
      });
      this.onDialogCancelled();
    },
    onStockCheckFilteredClick: function (payload) {
      console.log('payload',payload)
      this[ActionTypes.DistributionSupplierStockCheck.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        stocKProducts: payload || [],
      });
    },
    onContractAdded: function (e) {
      this[ActionTypes.RoyaltyAccountsContracts.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.supplier?.supplier_id,
        contracts: e || [],
      });
      this.onDialogCancelled();
    },
    onStatementAdded: function (e) {},
    onEditPaymentAdded: function (e) {
      const payments = this.selectedSupplierDetails.payments.map((p) => {
        if (p.payment_id === e.payment_id) {
          p = {
            ...e,
          };
        }
        return p;
      });

      this[ActionTypes.RoyaltyAccountsPayments.SET.ALL]({
        supplier_id: this.selectedSupplierDetails?.account?.supplier_id,
        payments: payments || [],
      });
      this.onDialogCancelled();
    },

    onSelectedContract: function (selectedContractId) {
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: selectedContractId,
          tab: "overview",
        },
      });
    },
    onSupplyOrderAdded(item) {
      this.$router.push({
        name: distributionSupplierOrderListLDTRoutes.names.tab,
        params: {
          supplier_order_id: item.supplier_order_id,
          tab: "overview",
        },
      });
    },

    onContactSelected: function (selectedContactId) {
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: selectedContactId,
          tab: "overview",
        },
      });
    },
    onSupplierOrderItemChanged: function (payload) {
      const res = SuppliersService.modify({
        ...payload,
      });
    },
    onSupplierItemChanged: function (payload) {
      const res = SuppliersService.modify({
        ...payload,
      });
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-suppliers-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 149px);
  }
  .contract-document {
    margin: 0px;
  }
}
</style>
